module.exports = __webpack_public_path__ + "img/empty-team-red.13d16aa.svg";